<template>
    <div>
      <!-- 手机  头部  -->
      <ul class="wap_menu">
        <li class="wm1"><img src="../assets/images/common/ilogo.png"></li>
<!--        <li class="wm2" @click="menuBtn"><img src="../assets/images/common/top_menu.png" alt=""></li>-->
<!--         <li class="wm3"><a href="http://www.cityplus.com/"><img src="../assets/images/common/top_btn_ch.png"></a></li>-->
        <li class="wm4" @click="userBtn" v-show="btnShow">
          <i class="el-icon-user-solid"></i>
        </li>
      </ul>
      <!-- end 手机  头部 -->
      <!-- 手机菜单  -->
      <div class="wap_menu_content" v-show="imenuShowA">
        <div><a href="http://www.cityplus.com/main/EN/index-en.html">Home</a></div>
        <div class="label">
          <span @click="imainSel(1)">The CITY<i :class="imainShow===1?'is-open':''" class="el-icon-arrow-right"></i></span>
          <div v-show="imainShow===1">
            <router-link to="/cityA1e" class="min">About Shenzhen</router-link>
            <router-link to="/cityA2e" class="min">Industries</router-link>
            <router-link to="/cityA3e" class="min">Innovation</router-link>
            <router-link to="/cityA4e" class="min">Green Development</router-link>
<!--            <a href="" class="min">城市人文</a>-->
            <router-link to="/cityA6e" class="min">More</router-link>
          </div>
        </div>
        <div class="label">
          <span @click="imainSel(2)">The ADVENTURE<i :class="imainShow===2?'is-open':''" class="el-icon-arrow-right"></i></span>
          <div v-show="imainShow===2">
            <a href="http://www.cityplus.com/main/EN/shenzhen.html" class="min">Just shenzhen</a>
            <a href="http://www.cityplus.com/main/EN/sz_line.html" class="min">Whole-City Discovery Route</a>
            <router-link to="/cityB2e" class="min">Eco-Discovery Route</router-link>
            <router-link to="/cityB3e" class="min">Culture & Creative Route</router-link>
          </div>
        </div>
        <div class="label"><span @click="imainSel(3)">The BUZZ<i :class="imainShow===3?'is-open':''" class="el-icon-arrow-right"></i></span>
          <div v-show="imainShow===3">
            <a href="http://www.cityplus.com/main/EN/events.html" class="min">The Focus</a>
<!--            <router-link to="/Activities" class="min">Activities</router-link>-->
          </div>
        </div>
        <div class="label"><span @click="imainSel(4)">The LIFE<i :class="imainShow===4?'is-open':''" class="el-icon-arrow-right"></i></span>
          <div v-show="imainShow===4">
            <router-link to="/cityDe" class="min">Subsidies</router-link>
          </div>
        </div>
        <div class="label"><span @click="imainSel(5)">The NETWORK<i :class="imainShow===5?'is-open':''" class="el-icon-arrow-right"></i></span>
          <div v-show="imainShow===5">
            <router-link to="/cityE1e" class="min">Cities</router-link>
            <router-link to="/cityE2e" class="min">Friendship Cities</router-link>
          </div>
        </div>
        <div class="label"><span @click="imainSel(6)">The WEBSITE<i :class="imainShow===6?'is-open':''" class="el-icon-arrow-right"></i></span>
          <div v-show="imainShow===6">
            <router-link to="/cityF1e" class="min">About Us</router-link>
          </div>
        </div>
<!--        <ul>-->
<!--          <li><a href=""><img src="../assets/images/common/ico_search.png">搜索网站</a></li>-->
<!--          <li><a href=""><img src="../assets/images/common/ico_iuser.png">登录注册</a></li>-->
<!--          <li><a href=""><img src="../assets/images/common/ico_iweixin.png" style="width: .53rem;">官方微信</a></li>-->
<!--          <li><a href=""><img src="../assets/images/common/ico_iapp.png">官方APP</a></li>-->
<!--        </ul>-->
      </div>
      <!-- END 手机菜单  -->
    </div>
</template>
<script>
import { getInitcode, getRequestcode } from '@/api-en'
import qs from 'qs'
import { NaccountLogin, getUserinfo } from '@/api'
export default {
  data () {
    return {
      imainShow: 0,
      imenuShowA: false,
      btnShow: true
    }
  },
  methods: {
    imainSel (e) {
      if (this.imainShow === e) {
        this.imainShow = 0
      } else {
        this.imainShow = e
      }
    },
    menuBtn () {
      this.imenuShowA = !this.imenuShowA
    },
    userBtn () {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      if(userInfo.userName == 'yk'){
        this.$confirm('To log in, please click the button below', 'Tips', {
          confirmButtonText: 'Confirm',
          type: 'warning',
          center: true,
          showCancelButton: false,
          showClose: false,
          closeOnPressEscape: false
        }).then(() => {
          if (sc.isSZSMT()) {
            console.log('在i深圳平台')
            this.$parent.$parent.$parent.$parent.linkIshenzhen()
          } else {
            console.log('不在i深圳平台内')
            this.$router.push('/LoginEN')
          }
        })
      } else {
        this.$router.push('/userEN')
      }
    }
  },
  mounted () {
    if (this.$route.name == 'book') {
      this.btnShow = false
    } else {
      this.btnShow = true
    }
  }
}
</script>

<style scoped>
.wap_menu{width: 100%;height: 1.1rem; background-color: rgba(0,0,0,0.7); position: fixed; top: 0; left: 0; z-index: 999;}
.wap_menu .wm1{width: 4rem; text-align: center; float: left;}
.wap_menu .wm1 img{width: 3rem;margin-top: .15rem;}
.wap_menu .wm3{width: .96rem; float: right;}
.wap_menu .wm3 img{width: .5rem; margin-top: .35rem;margin-right: 0.5rem}
.wap_menu .wm4{width: .96rem; float: right;}
.wap_menu .wm4 i{width: .5rem; margin-top: .35rem;margin-right: 0.4rem;font-size: 0.46rem;color: #10b7d1}
.wap_menu .wm2{    width: 0.9rem;
  height: 100%;
  float: right;
  display: flex;
  align-items: center;
}
.wap_menu .wm2 i{
  font-size: 0.6rem;
  color: #10b7d1;
}
.wap_menu .wm2 img{width: .45rem;}
.wap_banner_events{width: 100%; position: relative;}
.wap_banner_events .title{width: 2.5rem; position: absolute; top:2.18rem; left: .25rem;}
.wap_location{position:absolute; left: .25rem; bottom: 0; width: 2.6rem; height: .4rem; background-color: #0fb7d1;}
.wap_location div{width: 95%; padding-left: 5%; height: .4rem;  display: table-cell; vertical-align: middle; color: #fff; font-size: .22rem;}
.wap_menu_content{position: fixed;top: 1.1rem; left: 0; background-color: #10b7d1; width: 100%; height: 100%; overflow: hidden;  z-index: 999;padding-top: 0.8rem;}
.wap_menu_content a{color: #fff;}
.wap_menu_content div{
  padding-left: 1rem;
  font-size: .4rem;
  margin-top: .5rem;
  display: block;
  text-align: left;
}
.wap_menu_content .min{
  height: .5rem;
  margin-top: 0.2rem;
  line-height: .5rem;
  font-size: .35rem;
  display: block;
}
.wap_menu_content div.cur{background-color: #0da3ba;}
.wap_menu_content div.cur .min{display: block;}
.wap_menu_content ul{width: 9rem; height: auto; overflow: hidden; margin: .1rem auto 0;margin-top: .5rem}
.wap_menu_content ul li{width: 4.4rem; float: left; height: 1rem;}
.wap_menu_content ul li:nth-child(even){float: right;}
.wap_menu_content ul li a{width: 4.4rem; height: .94rem; display: table-cell; text-align: center; vertical-align: middle; background-color: #0da4bc; font-size: .24rem;}
.wap_menu_content ul li a img{width: .46rem; margin-right: .1rem; vertical-align: middle;}
/*.wap_menu_content div:nth-child(1){margin-top: .2rem;}*/
/*.wap_menu_content div a:nth-last-child(){ background-color: chartreuse}*/
.wap_menu_content div span i{
  float: right;
  color: #fff;
  margin-right: .6rem;
  transition: all .3s ease-out 0s;
}
.wap_menu_content .label span{
  color: #fff;
}
.wap_menu_content .is-open{transform: rotate(90deg);}
</style>
